import { render, staticRenderFns } from "./CreateAffiliationFromList.vue?vue&type=template&id=c8e15f5a&"
import script from "./CreateAffiliationFromList.vue?vue&type=script&lang=js&"
export * from "./CreateAffiliationFromList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports